import { render, staticRenderFns } from "./ShareItems.vue?vue&type=template&id=25a94f77&scoped=true&"
import script from "./ShareItems.vue?vue&type=script&lang=js&"
export * from "./ShareItems.vue?vue&type=script&lang=js&"
import style0 from "./ShareItems.vue?vue&type=style&index=0&id=25a94f77&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a94f77",
  null
  
)

export default component.exports